<div class="q9-sys-admin-app">
  <q9-page-loader [isLoading]="isLoading()"></q9-page-loader>
  <q9-loading-placeholder [isLoading]="isLoading()"></q9-loading-placeholder>

  <router-outlet></router-outlet>
</div>
